import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Salutation } from "../JobInputData";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import ModalHeader from "../ModalHeader";
import { EditApplication, reset } from "../../features/Applicant/applicantSlice";
import moment from "moment";

const EditApplicant = ({ name, id }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();


  const { EditapplicantionisError, EditapplicantionisSuccess, Editapplicantionmessage, EditapplicantionisLoading } = useAppSelector((state: { applicant: any; }) => state.applicant)


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [input, setInput] = useState({
    title: "",
    firstName: "",
    middleName: "",
    LastName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    offerLetterUrl: "",
  })


  useEffect(() => {
    if (EditapplicantionisError) {
      swal({
        title: "error",
        text: Editapplicantionmessage,
        icon: "error"
      })
    } else if (EditapplicantionisSuccess) {
      swal({
        title: "success",
        text: "User Edited!",
        icon: "success"
      })
      setShow(false)
      setInput(
        {
          title: "",
          firstName: "",
          middleName: "",
          LastName: "",
          email: "",
          phoneNumber: "",
          dateOfBirth: "",
          gender: "",
          offerLetterUrl: "",
        }
      )
    }
    dispatch(reset())
  }, [EditapplicantionisError, EditapplicantionisSuccess, Editapplicantionmessage, dispatch, navigate])


  const handleOnChange = (input: any, value: any) => {
    setInput((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };

  useEffect(() => {
    setInput((prevState: any) => {
      return ({
        ...prevState,
        title: name?.title,
        firstName: name?.firstName,
        middleName: name?.middleName,
        LastName: name?.LastName,
        email: name?.email,
        phoneNumber: name?.phoneNumber,
        dateOfBirth: name.dateOfBirth,
        gender: name?.gender,
        offerLetterUrl: name?.offerLetterUrl,
      });
    });
  }, [setInput, name]);





  const formattedInput = input.dateOfBirth
    ? { ...input, dateOfBirth: moment(input.dateOfBirth).format('DD-MM-YYYY') }
    : input;



  const handleSubmit = () => {
    const inputs = { formattedInput, id };
    // @ts-ignore 
    dispatch(EditApplication(inputs))
  }



  const inputDate = name.dateOfBirth || '';
  const formattedDate = inputDate ? moment(inputDate).format('YYYY-MM-DD') : '';


  return (
    <>
      <button className="admin-btn-progress" onClick={handleShow} >
        EDIT USER
      </button>
      <Modal show={show} onHide={handleClose} centered>
        <ModalHeader setShow={setShow} headerTitle={"Edit User"} />
        <Modal.Body>
          <div>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              {`${name?.title} ${name?.firstName} ${name?.middleName} ${name?.LastName}`}
            </div>
            <br />

            <form onSubmit={handleSubmit} >
              <div className='reviewer-name'>
                <div className="user__details">
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Title</span>
                    <select name="country" id="register-select"
                      value={input.title}
                      onChange={(e) => handleOnChange("title", e.target.value)}>
                      <option value="">Select Title</option>
                      {Salutation?.map((item: any, i: any) => (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">First Name</span>
                    <input type="text" placeholder="E.g: John Smith"
                      value={input.firstName}
                      onChange={(e) => handleOnChange("firstName", e.target.value)}
                    />
                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Middle Name</span>
                    <input type="text" placeholder="E.g: John Smith"
                      value={input.middleName}
                      onChange={(e) => handleOnChange("middleName", e.target.value)}
                    />
                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Last Name</span>
                    <input type="text" placeholder="johnWC98"
                      value={input.LastName}
                      onChange={(e) => handleOnChange("LastName", e.target.value)}
                    />
                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Email</span>
                    <input type="email" placeholder="johnsmith@hotmail.com"
                      value={input.email}
                      onChange={(e) => handleOnChange("email", e.target.value)}
                    />

                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Phone Number</span>
                    <input type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" placeholder="012-345-6789"
                      value={input.phoneNumber}
                      onChange={(e) => handleOnChange("phoneNumber", e.target.value)}
                    />

                  </div>
                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Date Of Birth</span>
                    <input type="date" placeholder="12/4/2024"
                      value={!input.dateOfBirth ? formattedDate : input.dateOfBirth}
                      onChange={(e) => handleOnChange("dateOfBirth", e.target.value)} />
                  </div>

                  <div className="input__box" style={{ width: "100%" }}>
                    <span className="details">Gender</span>
                    <select name="country" id="register-select"
                      value={input.gender}
                      onChange={(e) => handleOnChange("gender", e.target.value)}>
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    <div className="input__box mt-3" style={{ width: "100%" }}>
                      <span className="details">Offer Letter Url</span>
                      <input type="text" placeholder="offer letter url"
                        value={input.offerLetterUrl}
                        onChange={(e) => handleOnChange("offerLetterUrl", e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleSubmit}>
            {EditapplicantionisLoading ? <Spinners size={"sm"} /> : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditApplicant;
